export default "__VITE_ASSET__olyeK4rl__"